export enum AccessLevels {
	NONE,
	READ,
	COPY,
	EDIT
}
